<template>
  <content-items-view
    content-type="playlists"
    content-type-singular="playlist"
    content-name="Playlists"
    content-name-singular="Playlist"
  />
</template>

<script>
import ContentItemsView from '@/views/content-item/content-items-view/ContentItemsView.vue'

export default {
  components: {
    ContentItemsView,
  },
}
</script>

<style scoped>

</style>
